export default {
  SET_FIELDS(state, fields) {
    state.fields = fields
  },
  REMOVE_FIELDS(state, itemId) {
      const roleIndex = state.fields.datas.findIndex((u) => u.id == itemId)
      state.fields.datas.splice(roleIndex, 1)
  },
  SELECTED_FIELDS(state,data){
    state.fields.datas = []
    state.fields.total = 1;
    state.fields.per_page = 1;
    state.fields.datas.push(data)
  },
  SET_AUTOCOMPLETE_DATA(state,data){
    state.autocomplete_data = data
  },
  EDIT_ITEM(state,data){
    state.elomark_user = data
  },
  ADD_ITEM(state,data){
    state.elomark_user = data
  },
}
